// --- NEW: Spiderweb SVG Component ---
export const SpiderwebEffect = ({ isSelected }) => {
    const baseClasses = "absolute top-0 right-0 w-48 h-48 transition-colors duration-300 z-0";
    const stateClasses = isSelected 
        ? 'text-orange-500/40 dark:text-brand-500/40' 
        : 'text-gray-200/80 dark:text-navy-600/50 group-hover:text-orange-500/40 dark:group-hover:text-brand-500/40';

    return (
        <svg 
            className={`${baseClasses} ${stateClasses}`}
            fill="none" 
            viewBox="0 0 100 100" 
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M100 0 L50 50" stroke="currentColor" strokeWidth="0.5"/>
            <path d="M100 0 L75 25" stroke="currentColor" strokeWidth="0.5"/>
            <path d="M100 0 L25 75" stroke="currentColor" strokeWidth="0.5"/>
            <path d="M100 0 L0 100" stroke="currentColor" strokeWidth="0.5"/>
            <path d="M100 0 L-25 125" stroke="currentColor" strokeWidth="0.5"/>
            <path d="M100 0 L125 -25" stroke="currentColor" strokeWidth="0.5"/>
            <path d="M100 0 L80 80" stroke="currentColor" strokeWidth="0.5" transform="translate(-30, -30)"/>
            <path d="M100 0 L100 50" stroke="currentColor" strokeWidth="0.5"/>
            <path d="M100 0 L50 100" stroke="currentColor" strokeWidth="0.5"/>
            <path d="M100 0 L100 100" stroke="currentColor" strokeWidth="0.5"/>
            <path d="M90 10 A 80 80 0 0 1 10 90" stroke="currentColor" strokeWidth="0.5" fill="none"/>
            <path d="M95 5 A 90 90 0 0 1 5 95" stroke="currentColor" strokeWidth="0.5" fill="none"/>
            <path d="M80 20 A 60 60 0 0 1 20 80" stroke="currentColor" strokeWidth="0.5" fill="none"/>
            <path d="M70 30 A 40 40 0 0 1 30 70" stroke="currentColor" strokeWidth="0.5" fill="none"/>
        </svg>
    );
};

export const HeaderWebEffect =({}) => {
    return (
        <svg
              className="absolute top-0 right-0 z-0 h-auto w-1/3 text-orange-500/10"
              viewBox="0 0 100 100"
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              aria-hidden="true"
          >
              <g fill="none" stroke="currentColor" stroke-width="0.75" stroke-linecap="round">
                  <path d="M100 0 L0 100" />
                  <path d="M100 0 L20 100" />
                  <path d="M100 0 L40 100" />
                  <path d="M100 0 L60 100" />
                  <path d="M100 0 L80 100" />
                  <path d="M100 0 L100 80" />
                  <path d="M100 0 L100 60" />
                  <path d="M100 0 L100 40" />
                  <path d="M100 0 L100 20" />
                  <path d="M100 15 A 85 85 0 0 1 15 100" />
                  <path d="M100 30 A 70 70 0 0 1 30 100" />
                  <path d="M100 45 A 55 55 0 0 1 45 100" />
                  <path d="M100 60 A 40 40 0 0 1 60 100" />
              </g>
          </svg>
    );
};